'use client';

import {
  Box,
  TextField,
  Typography,
  CheckboxListItem,
} from '@wishket/design-system';
import { ChangeEvent } from 'react';

import { CheckBoxItem } from './NewsletterDialogInput.parts';

import { NewsletterSubscriptionInfo } from '@/shared/types';

export interface NewsletterDialogInputProps {
  isCheckBoxError?: boolean;
  emailErrorMessage?: string;
  information: NewsletterSubscriptionInfo;
  onClickMore: (name: string) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>, name: string) => void;
}

const NewsletterDialogInput = ({
  information,
  isCheckBoxError,
  emailErrorMessage,
  onChange,
  onClickMore,
}: NewsletterDialogInputProps) => {
  return (
    <Box className="flex flex-1 flex-col gap-4">
      <TextField
        className="mb-2"
        role="textbox"
        aria-label="Email Input"
        testId="newsletter-email-input"
        placeholder="이메일을 입력해 주세요."
        value={information.email}
        isError={!!emailErrorMessage}
        errorMessage={emailErrorMessage}
        onChange={(e) => onChange(e, 'email')}
      />
      <Box>
        <CheckboxListItem
          checked={
            information.agreement && information.usage && information.reception
          }
          className="w-fit"
          onChange={(e) => onChange(e, 'agreeAll')}
        >
          <Typography
            variant="subTitle2"
            className="select-none font-medium text-w-gray-900"
          >
            전체 동의하기
          </Typography>
        </CheckboxListItem>
        {isCheckBoxError && (
          <Typography
            data-testid="newsletter-agreement-error"
            variant="body3"
            className="top-full ml-[28px] flex-none font-normal text-w-red-500"
          >
            뉴스레터를 구독하려면 아래 모든 항목에 동의가 필요합니다.
          </Typography>
        )}
      </Box>
      <CheckBoxItem
        name="agreement"
        label="개인정보 수집·이용 동의"
        isError={isCheckBoxError && !information.agreement}
        checked={information.agreement}
        onChange={onChange}
        onClickMore={onClickMore}
      />
      <CheckBoxItem
        isOptional
        name="usage"
        label="개인정보 마케팅 활용 동의"
        checked={information.usage}
        onChange={onChange}
        onClickMore={onClickMore}
      />
      <CheckBoxItem
        isOptional
        name="reception"
        label="마케팅 정보 수신 동의"
        checked={information.reception}
        onChange={onChange}
        onClickMore={onClickMore}
      />
    </Box>
  );
};

export default NewsletterDialogInput;
